var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._g(_vm._b({ref:_vm.componentName,tag:"component",scopedSlots:_vm._u([{key:"cover",fn:function({ playEnd }){return [_vm._t("cover",null,{"playEnd":playEnd})]}}],null,true)},'component',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }